import attachment from "../../assets/icons/attachment.svg";
import pdf from "../../assets/icons/pdf.png";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import { useState } from "react";
const ViewExtraAttachments = (props) => {
  const { files } = props;
  const [onViewDocument, setOnViewDocument] = useState(false);
  const [document, setDocument] = useState(null);

  return (
    <>
        {onViewDocument && document && (
          <PreviewPdfUrl
            showDocument={onViewDocument}
            setShowDocument={() => setOnViewDocument(false)}
            document={{
              name: `${document.fileName}`,
              url:
                process.env.REACT_APP_FILES_URL +
                "/preview/" +
                document.docReferenceId,
            }}
          />
        )}
        {!!files.length &&  
         <div className="mt-3   p-2 w-100">
          <div className=" border-bottom border-secondary pb-1">
            <strong>Attached files({files.length})</strong>
          </div>

          <div
            className="mt-1 pl-2 pr-2 row"
            style={{
              maxHeight: "100px",
              overflow: "auto",
            }}
          >
        {files.map((file, index) => (
          <div key={index} className={files.length === 1 ? "col-12" : "col"}>
            <>
              <Chip
                avatar={<Avatar alt={file.fileName} src={pdf} />}
                style={{ marginTop: "5px" }}
                size="small"
                onClick={() => {
                  setOnViewDocument(true);
                  setDocument(file);
                }}
                label={
                  <>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#0d141d",
                        fontWeight: "600",
                        width: "calc(100% - 80px)",
                        overflow: "hidden",
                        textDecoration: "none",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      className="text-truncate text-lowercase"
                    >
                      {file.fileName}
                    </span>
                  </>
                }
                variant="outlined"
                color="primary"
                deleteIcon={<CloudDownloadIcon />}
                onDelete={() => {
                  setOnViewDocument(true);
                  setDocument(file);
                }}
              />
            </>
          </div>
        ))}
        </div>
      </div>}
       
    </>
  );
};

export default ViewExtraAttachments;
